import React, { useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import WhyUsSection from '../components/WhyUsSection';

const Home = () => {
  // Cargar script de Elfsight cuando el componente se monte
  useEffect(() => {
    // Crear script para Elfsight
    const script = document.createElement('script');
    script.src = 'https://de356b8f78b1480490fb849b2a5604bc.elf.site';
    script.async = true;

    // Crear script para el widget
    const widgetScript = document.createElement('script');
    widgetScript.src = 'https://static.elfsight.com/platform/platform.js';
    widgetScript.async = true;

    // Agregar scripts al head
    document.head.appendChild(script);
    document.head.appendChild(widgetScript);

    // Limpieza al desmontar
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(widgetScript);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <HeroSection />
      <WhyUsSection />

      {/* Widget de Elfsight - ANCHO COMPLETO */}
      <section className="pt-6 pb-2 w-full max-w-none px-0 mx-0">
        {/* Contenedor sin padding ni márgenes */}
        <div className="w-full max-w-none px-0 mx-0">
          <div
            className="elfsight-app-de356b8f-78b1-4804-90fb-849b2a5604bc w-full"
            data-elfsight-app-lazy
          ></div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-24 relative overflow-hidden">
        {/* Gradiente animado con background-size inline */}
        <div
          className="absolute inset-0 animate-gradient-shift-cta"
          style={{
            background:
              'linear-gradient(60deg, rgb(247,149,51), rgb(243,112,85), rgb(239,78,123), rgb(161,102,171), rgb(80,115,184), rgb(16,152,173), rgb(7,179,155), rgb(111,186,130))',
            backgroundSize: '400% 400%',
          }}
        ></div>

        {/* Olas animadas */}
        <div className="absolute top-0 right-0 w-1/3 h-full bg-white/5 transform skew-x-12 animate-wave-right"></div>
        <div className="absolute bottom-0 left-0 w-1/3 h-full bg-white/5 transform -skew-x-12 animate-wave-left"></div>

        {/* Elementos decorativos simplificados */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-32 translate-x-32 animate-float"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full translate-y-48 -translate-x-48 animate-float-delayed"></div>

        {/* Overlay para mejor contraste */}
        <div className="absolute inset-0 bg-black/10"></div>

        <div className="container relative z-10 mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 leading-tight">
            ¿Listo para unirte a nuestro equipo?
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
            Descubre las oportunidades que tenemos para ti y comienza tu carrera
            en una empresa líder del sector
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/vacantes"
              className="btn-primary bg-white text-gray-800 hover:bg-gray-50 hover:scale-105 transform transition-all duration-300 text-lg px-10 py-4 rounded-xl shadow-xl font-semibold"
            >
              Ver vacantes disponibles
            </a>
            <a
              href="https://packsys.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline border-2 border-white text-white hover:bg-white hover:text-gray-800 text-lg px-10 py-4 rounded-xl hover:scale-105 transform transition-all duration-300 font-semibold"
            >
              Conocer la empresa
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
